import { render, staticRenderFns } from "./del-param.vue?vue&type=template&id=787854b0"
import script from "./del-param.vue?vue&type=script&lang=js"
export * from "./del-param.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('787854b0')) {
      api.createRecord('787854b0', component.options)
    } else {
      api.reload('787854b0', component.options)
    }
    module.hot.accept("./del-param.vue?vue&type=template&id=787854b0", function () {
      api.rerender('787854b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product/topic-list/del-param.vue"
export default component.exports